import {
  isServer,
  QueryClient,
  QueryClientConfig,
} from '@tanstack/react-query';

/**
 * This creates the application react query client.
 * Please configure all the global parameters to the query here.
 */
export const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refetchOnWindowFocus: false,
      // refetchOnMount: false,
      // refetchOnReconnect: false,
      retry: 3,
      staleTime: 5 * 1000,
    },
  },
});

/**
 * This creates the application react query client for
 * Please configure all the global parameters to the query here.
 */
function makeWebServerQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

/**
 * This is an alternative to the `reactQueryClient` generated client since this
 * is only targeted for web applications while the `reactQueryClient` is used
 * for both web and react-native.
 */
export function getWebReactQueryClient() {
  if (isServer) {
    // Server: always make a new query client
    return makeWebServerQueryClient();
  }
  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  // Read More:: https://tanstack.com/query/latest/docs/framework/react/guides/advanced-ssr
  if (!browserQueryClient) browserQueryClient = makeWebServerQueryClient();

  return browserQueryClient;
}

/**
 * -----------------------------------------------------------------------------
 * This creates a function that will generate the query client with the passed
 * options.
 */
export function createQueryClient(options?: QueryClientConfig) {
  return new QueryClient(options);
}
